module.exports = __webpack_public_path__ + "static/media/철마산.2900e775.jpg";